/*  MUI  */
import { Checkbox, FormControlLabel } from '@mui/material';

/*  Shared  */
import { Helpers } from 'application/Shared/Helpers';
import { UserReq } from 'application/Shared/Requests';

/*  Objects  */
import { User, UserIconAndName } from 'objects/User';

/*  React  */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'router/withRouter';

/*  Components  */
import ObjectPicker from './Components/ObjectPicker';

/*  State  */
const state = () => ({
    includeInactive: false,
    loaded: false,
    objectPayload: [],
    selectedValue: false,
    users: []
});

class UserPicker extends Component {
    constructor(props) {
        super(props);
        this.state = state();
        const clientId = props?.match?.params?.clientId;
        /* requests */
        this.User = new UserReq(clientId);
    }

    componentDidMount() {
        this.load();
    }

    componentDidUpdate(prev) {
        const { freeInput, inputValue } = this.props;

        if (!freeInput) {
            return;
        }

        if (!inputValue) {
            return;
        }

        if (inputValue !== prev.inputValue) {
            this.loadPicker();
        }
    }

    componentWillUnmount() {
        this.unmounted = true;
        this.unload();
    }

    load = async () => {
        const users = await this.loadUsers();

        if (this.unmounted) {
            return;
        }

        this.setState({ users }, () => {
            this.loadPicker();
        });
    };

    unload = () => {
        this.User.cancel();
        this.setState(state());
    };

    loadUsers = async () => {
        const { hasValidEmail } = this.props;

        let data;
        try {
            data = await this.User.getAll({ smartSort: true });
            if (!data) {
                return [];
            }
        } catch (e) {
            return [];
        }

        const users = data.filter((user) => {
            const { email } = user;

            if (!hasValidEmail) {
                // email check
                return true;
            }

            if (Helpers.isEmail(email)) {
                return true;
            }
            return false;
        });

        return users.sort((a, b) =>
            `${a.smartSort}`.localeCompare(b.smartSort)
        );
    };

    loadPicker = () => {
        const { freeInput, hideInactiveUsersOption, inputValue, t } =
            this.props;
        const { users, includeInactive } = this.state;

        const objectPayload = users.map((u) => {
            const user = { ...u, hideOption: false };
            const { expired, hasActivity } = user;

            if (!includeInactive && (expired || !hasActivity)) {
                user.hideOption = true;
            }

            return {
                ...user,
                componentToDisplay: (
                    <User data={user}>
                        <div style={{ width: '100%' }}>
                            <UserIconAndName />
                        </div>
                    </User>
                )
            };
        });

        if (!hideInactiveUsersOption) {
            objectPayload.push({
                componentToDisplay: (
                    <FormControlLabel
                        onClick={() => this.handleCheckbox()}
                        control={<Checkbox checked={includeInactive} />}
                        label={t('Common.showDisabledExpiredUsers')}
                    />
                ),
                id: 'noVal'
            });
        }

        if (this.unmounted) {
            return;
        }

        if (
            freeInput &&
            inputValue !== 'noVal' &&
            !Helpers.isUUID(inputValue)
        ) {
            objectPayload.unshift({
                componentToDisplay: <span>{inputValue}</span>,
                id: inputValue,
                name: inputValue
            });
            this.setState({ selectedValue: inputValue });
        }

        this.setState({ loaded: true, objectPayload });
    };

    handleCheckbox = () => {
        const { includeInactive } = this.state;

        this.setState({ includeInactive: !includeInactive }, () =>
            this.loadPicker()
        );
    };

    render() {
        const { freeInput } = this.props;
        const { loaded, objectPayload, selectedValue } = this.state;

        if (!loaded) {
            return null;
        }

        return (
            <ObjectPicker
                {...this.props}
                objectPayload={objectPayload}
                objectNameField="name"
                objectNameFieldVisualOnly="componentToDisplay"
                freeInput={freeInput}
                selectedValue={selectedValue}
            />
        );
    }
}

export default withTranslation()(withRouter(UserPicker));
